import { GameState } from './GameState';
import { LevelTemplateKey } from './templates/LevelTemplate';

export class GameConfig {
  static logDebug: boolean = true;
  static logInfo: boolean = true;
  static initialLives: number = 3;

  debug: boolean = false;

  debugLayer: boolean = true;
  debugFps: boolean = false;
  debugBodies: boolean = false;
  debugNavMesh: boolean = false;
  mute: boolean = false;
  debugPaths: boolean = false;
  debugPathBoundaries: boolean = true;
  sceneViewer: boolean = false;
  godMode: boolean = true;

  levelKey?: string = 'test';
  levelTemplate: LevelTemplateKey = 'Mountains';
  state?: GameState = GameState.MAIN;
}
